const getContent = (svg: string) => `url("data:image/svg+xml;utf8,${svg}")`;

export const getIconRule = (svgString: string) => {
    return {
        whiteSpace: "nowrap",
        "& span": {
            whiteSpace: "normal",
        },
        "&::before": {
            width: "16px",
            height: "16px",
            content: getContent(svgString),
            display: "inline-flex",
            alignSelf: "center",
            boxSize: "16px",
            mr: 0.5,
            verticalAlign: "middle",
        },
    };
};
